import { NgModule, ModuleWithProviders, EnvironmentInjector } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Database } from "@angular/fire/database";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { FirebaseTransLoader } from "../../shared/firebase-trans-loader";
import { MissingTranslationHandler } from "@ngx-translate/core";
import { MyMissingTranslationHandler } from "../../shared/firebase-trans-loader";
import { ConnectionRouterComponent } from "../../shared/connection-router/connection-router.component";
import { ExtraScrollComponent } from "../../shared/extra-scroll/extra-scroll.component";
import { CloseDialogButtonComponent } from "../../shared/close-dialog-button/close-dialog-button.component";
import { AuthService } from "../../providers/auth.service";
import { AppStatsService } from "../../providers/app-stats.service";
import { LocationService } from "../../providers/location.service";
import { TrackingService } from "../../providers/tracking.service";
import { UtilService } from "../../providers/util.service";
import { SiteFooterComponent } from "../../shared/site-footer/site-footer.component";
import { SubscriptionService } from "../../providers/subscription.service";
import { EmailService } from "../../providers/email.service";
import { LogProcessService } from "../../providers/log-process.service";
import { AudioService } from "../../providers/audio.service";
import { RunningClockService } from "../../providers/running-clock.service";
import { ThermalPrinterService } from "../../providers/thermal-printer.service";
import { PrinterBridgeService } from "../../providers/printer-bridge.service";
import { PaperSizeService } from "../../providers/paper-size.service";
import { PaperSizePromptComponent } from "../../shared/paper-size-prompt/paper-size-prompt.component";
import { MaxPlayersComponent } from "../../shared/max-players/max-players.component";
import { AnnouncementComponent } from "../../shared/announcement/announcement.component";
import { LoadingOverlayComponent } from "../../shared/loading-overlay/loading-overlay.component";
import { PricingWebComponentModule } from "../../shared/components/pricing-web-component/pricing-web-component.module";
import { FileInputComponent } from "../../shared/file-input/file-input.component";
import { AlertDialogComponent } from "../../shared/alert-dialog/alert-dialog.component";
import { ConfirmDialogComponent } from "../../shared/confirm-dialog/confirm-dialog.component";
import { PromptDialogComponent } from "../../shared/prompt-dialog/prompt-dialog.component";
import { StatusBadgeComponent } from "../../shared/status-badge/status-badge.component";
import { FormsModule } from "@angular/forms";
import { FeatureLockComponent } from "../../shared/feature-lock/feature-lock.component";
import { LockedFeatureDialogComponent } from "../../shared/feature-lock/locked-feature-dialog.component";
import { TcAcceptanceDialogComponent } from "../../shared/tc-acceptance-dialog/tc-acceptance-dialog.component";
import { TournamentRegisterButtonComponent } from "../../shared/tournament-register-button/tournament-register-button.component";
import { DesignSystemModule } from "../../design-system/design-system.module";

export function FbTransLoaderFactory(
  mdb: Database,
  injector: EnvironmentInjector
) {
  return new FirebaseTransLoader(mdb, injector);
}
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DesignSystemModule,
        PricingWebComponentModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: FbTransLoaderFactory,
                deps: [Database, EnvironmentInjector],
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MyMissingTranslationHandler,
            },
        }),
        ConnectionRouterComponent,
        ExtraScrollComponent,
        CloseDialogButtonComponent,
        SiteFooterComponent,
        MaxPlayersComponent,
        AnnouncementComponent,
        LoadingOverlayComponent,
        FileInputComponent,
        AlertDialogComponent,
        ConfirmDialogComponent,
        PromptDialogComponent,
        StatusBadgeComponent,
        FeatureLockComponent,
        LockedFeatureDialogComponent,
        TcAcceptanceDialogComponent,
        PaperSizePromptComponent,
        TournamentRegisterButtonComponent,
    ],
    exports: [
        ConnectionRouterComponent,
        ExtraScrollComponent,
        CloseDialogButtonComponent,
        TranslateModule,
        SiteFooterComponent,
        MaxPlayersComponent,
        AnnouncementComponent,
        LoadingOverlayComponent,
        PricingWebComponentModule,
        FileInputComponent,
        StatusBadgeComponent,
        FeatureLockComponent,
        LockedFeatureDialogComponent,
        TcAcceptanceDialogComponent,
        PaperSizePromptComponent,
        TournamentRegisterButtonComponent,
    ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthService,
        AppStatsService,
        LocationService,
        TrackingService,
        SubscriptionService,
        EmailService,
        LogProcessService,
        AudioService,
        UtilService,
        RunningClockService,
        ThermalPrinterService,
        PrinterBridgeService,
      ],
    };
  }
}
